import { Component, Prop, Vue } from "vue-property-decorator"

@Component
export default class FormField extends Vue {
    @Prop()
    value!: any

    @Prop({ type: Boolean, default: false })
    editable!: boolean

    @Prop({ type: Boolean, default: false })
    editing!: boolean

    @Prop({ type: Boolean, default: false })
    required!: boolean

    @Prop({ type: Boolean, default: false })
    showOnDetailView!: boolean

    @Prop()
    parentForm!: string

    groupIdOrUuid() {
        return this.value && (this.value.groupUuid ? this.value.groupUuid : (this.value.id ? this.value.id : null))
    }

    mounted() {}
}
